import React from 'react';
import { useLang } from '../i18n/LangContext';
import { LOCALES } from '../lib/dates';

// Month + year picker in the interface language; value/onChange use 'YYYY-MM'
export const MonthField = ({ value, onChange, testid, className = '' }) => {
  const { lang } = useLang();
  const [y, m] = (value || '').split('-');
  const loc = LOCALES[lang] || LOCALES.es;
  const months = Array.from({ length: 12 }, (_, i) => loc.localize.month(i, { width: 'wide' }));
  const now = new Date().getFullYear();
  const years = Array.from({ length: 41 }, (_, i) => now + 1 - i);
  const cls = 'bg-slate-900 border border-slate-700 rounded-lg px-2 py-2 text-white text-sm capitalize focus:border-blue-500 focus:outline-none';
  const set = (ny, nm) => onChange(ny && nm ? `${ny}-${nm}` : '');
  return (
    <div className={`flex gap-2 ${className}`} data-testid={testid}>
      <select data-testid={`${testid}-month`} value={m || ''} onChange={(e) => set(y || String(now), e.target.value)} className={`${cls} flex-1`}>
        <option value="">—</option>
        {months.map((n, i) => <option key={i} value={String(i + 1).padStart(2, '0')}>{n}</option>)}
      </select>
      <select data-testid={`${testid}-year`} value={y || ''} onChange={(e) => set(e.target.value, m || '01')} className={cls}>
        <option value="">—</option>
        {years.map((n) => <option key={n} value={n}>{n}</option>)}
      </select>
    </div>
  );
};
